import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationPtBr from './locales/pt-br/translation.json';

//translations
const resources = {
    ptbr: {
        translation: translationPtBr,
    }
};

i18n.use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'ptbr',
        fallbackLng: 'ptbr',

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;

export const t = (key: string) => i18n.t(key);
